<template>
  <div class="animated fadeIn">
    <b-row class="mt-3" >
      <b-col sm="12" class="text-center">
        <h1 style="color: green;"><i class="fa fa-check"></i></h1>
        <h1 style="color: green;">{{ebookPrice == 0 ? "Por ser cliente fiel do Sleeker, seu eBook será gerado gratuitamente e enviado para o seu Email" : "Seu pedido foi registrado!"}}</h1>
      </b-col>
    </b-row>
    <b-row class="mt-3" >
      <b-col sm="4" offset-sm="4" class="text-center">
        <b-input type="email" v-model="email" placeholder="seuemail@exemplo.com"></b-input>
      </b-col>
    </b-row>
    <b-row class="mt-3" >
      <b-col sm="6" offset-sm="3">
        <b-button @click="goToPayments()" v-bind:disabled="!email" variant="success" style="width: 100%;">Pagar e receber meu eBook</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";


export default {
  name: 'Tutorial',
  data () {
    return {
      isMobileScreen: isMobile,
      tutorials:  [],
      pendingEmailConfirmation: false,
      ebookPrice: 27,
      email: ""
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    }
  },
  methods: {
    goToPayments: function() {
      service.saveCustomEbookEmail(this.email, this.$route.params.id).then(() => {
        let url = "https://pag.ae/7WQsjuNNP";
        window.location.href = url;
      });
    }
  },
  created() {

  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
